import {Component, Input} from '@angular/core';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';


@Component({
    selector: 'app-no-data-message',
    templateUrl: './no-data-message.component.html',
    styleUrls: ['./no-data-message.component.scss'],
    standalone: true,
    imports: [LocalizeTextPipe]
})
export class NoDataMessageComponent {
  @Input() customMessage: string = null;
}
